module.exports = __webpack_public_path__ + "img/page_accueil.d33f1893.jpg";